export type UserDataType = UserModel | undefined;
export const ROLE_ADMIN = 'admin';
export const ROLE_TECH = 'tech';
export const ROLE_MANAGER = 'manager';
export const ROLE_DISTRIBUTOR = 'distributor';

export interface UserModel {     
    uid: string;
    email: string;
    displayName: string;
    photoURL: string; 
    role: string;
    club?: string;    
    permissions?: string[];
    teams?: string[];
    errorMessage?: string;     
}

export interface UserProfile {
    user: {
        club: string;
        role: string;
        squads: any;        
        active_squad: string;
        first_name: string;
        last_name: string;
        picture?: string;
        position_title?: string;
        profile?: {
            teams?: string[];
        }        
    }   
}
